import { styled } from '@mui/material';

import { Skeleton } from '../../atoms/Skeleton';

const Row = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.25),
  minHeight: theme.spacing(5.5),
  padding: theme.spacing(1),
}));

const Line = styled('span')<{ ownerState: { width: string } }>(({ ownerState }) => ({
  display: 'block',
  width: ownerState.width,
}));

/** Placeholder row matching `NotificationListItem` while notifications load. */
export function NotificationListItemSkeleton() {
  return (
    <li aria-hidden="true" data-testid="notification-list-item-skeleton">
      <Row>
        <Line ownerState={{ width: '90%' }}><Skeleton variant="text" /></Line>
        <Line ownerState={{ width: '35%' }}><Skeleton variant="text" /></Line>
      </Row>
    </li>
  );
}
